<template>
  <ul class="navbar-nav mr-auto">
    <li
      class="nav-item"
      v-if="isAuthenticated"
    >
      <div
        class="wp_UserDp"
        v-if="profilePic"
      >
        <img
          :src="profilePic"
          alt="profilePic"
										data-test="authenticatedUserModalImg1"
										id="authenticatedUserModalImg1"
        >
      </div>
      <div
        class="wp_UserDp"
        v-else
      >
        <img
          src="@/assets/img/no-profile-image.png"
          alt="profilePic"
										data-test="authenticatedUserModalImg2"
										id="authenticatedUserModalImg2"
        >
      </div>

      <span id="username-welcome-span">
        <span
          class="text-capitalize wp_HeaderMenuItemsText"
          id="authenticatedUserModalSpan1-username-span"
										data-test="authenticatedUserModalSpan1"
        >
          {{getUserData.firstname?getUserData.firstname:'Guest'}}
        </span>
      </span>
    </li>
    <li
      class="nav-item"
      v-else
    >
      <div class="wp_UserDp">
        <img
          src="@/assets/img/no-profile-image.png"
          alt="profilePic"
										data-test="authenticatedUserModalImg3"
										id="authenticatedUserModalImg3"
        >
      </div>
      <un-authenticated-models>
      </un-authenticated-models>
    </li>
    <li
      class="nav-item"
      v-if="isAuthenticated"
    >
      <div class="d-flex justify-content-end align-items-center">
        <div class="dropdown wp_HeaderMenuItemsText">
          <button
            class="btn-my-account dropdown-toggle"
            type="button"
            id="authenticatedUserModalBtn1-btnDropdownDemo"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
												data-test="authenticatedUserModalBtn1"
          >
            My Account
          </button>
          <ul
            class="dropdown-menu my-account wp_dropDownClassMyAccount"
            aria-labelledby="btnDropdownDemo"
          >
            <li
              v-for="(pathName, index) in userRouteListPaths"
              :key="index"
              @click="userRoutes(pathName.name)"
              style="cursor: pointer"
														:data-test="'authenticatedUserModalList'+index"
														:id="'authenticatedUserModalList'+index"
            >
              <router-link
                :to="{ name: pathName.name}"
                class="dropdown-item"
                :id="'authenticatedUserModalLink-userprofile-mob-link'+index"
																:data-test="'authenticatedUserModalLink'+index"
              >
                {{pathName.label}}
              </router-link>
            </li>
            <li
              @click="logOut"
              style="cursor: pointer"
														data-test="authenticatedUserModalLogoutList"
														id="authenticatedUserModalLogoutList"
            >
              <a
                class="dropdown-item"
                id="authenticatedUserModalLogoutLink-userLogout-mob-link-header-one"
																data-test="authenticatedUserModalLogoutLink"
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
        <!--<div id="user-dropdwn"-->
        <!--class="region with-flyout"-->
        <!--data-flyout-content=""-->
        <!--&gt;-->
        <!--<div class="flyout cbt-popUp user-flyout">-->
        <!--<ul id="cbt-popUp-1" class="option2">-->
        <!--<li v-for="(pathName, index) in userRouteListPaths"-->
        <!--:key="index"-->
        <!--&gt;-->
        <!--<router-link :to="{ name: pathName.name}"-->
        <!--class="dropdown-item"-->
        <!--:id="'userprofile-mob-link'+index"-->
        <!--&gt;-->
        <!--{{pathName.label}}-->
        <!--</router-link>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a href=""-->
        <!--@click.prevent="logOut"-->
        <!--class="dropdown-item"-->
        <!--id="userLogout-mob-link-header"-->
        <!--&gt;-->
        <!--Logout-->
        <!--</a>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </li>
    <li class="nav-item">
      <div
        class="region with-flyout country-select"
        data-flyout-content
      >
        <a
          id="authenticatedUserModalCountryLink-ship-to"
          @click.prevent="toggleDropDown('country-select')"
          href
          data-flyout="cbt-popUp"
          :title="getSelectedCountry.country_name"
										data-test="authenticatedUserModalCountryLink"
        >
          <i v-if="(getSelectedCountry && getSelectedCountry.country_flag)"
													data-test="authenticatedUserModalCountryI1" id="authenticatedUserModalCountryI1">
            <img
              :src="getSelectedCountry.country_flag"
              style="width: 32px;"
              :alt="getSelectedCountry.country_name"
              id="authenticatedUserModalCountryImg-country-img"
														data-test="authenticatedUserModalCountryImg"
            >
          </i>
          <i
            class="ae"
            v-else
            id="authenticatedUserModalCountryI2-ae"
												data-test="authenticatedUserModalCountryI2"
          ></i>
        </a>
        <div
          style="display: none;"
          class="wp_countrySelectingContainer"
          id="country-select"
        >
          <!--<ul id="cbt-popUp-one" class="option2">-->
          <!--<li>-->
          <!--<label>-->
          <!--<b id="country-label">Ship to </b>-->
          <!--</label>-->
          <country-picker>
          </country-picker>
          <!--</li>-->
          <!--</ul>-->
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import CountryPicker from '@/components/shared/widgets/CountryPicker'
import UnAuthenticatedModels from '@/components/shared/widgets/UnAuthenticatedModels'
import { countrySelector } from '../../../commonJs/CountrySelector'

export default {
	data () {
		return {
			userRouteListPaths: [
				{ name: 'UserProfile', label: 'Profile' },
				{ name: 'Orders', label: 'Orders' },
				{ name: 'WishList', label: 'Wishlist' }
			],
			profilePic: ''
		}
	},
	components: {
		CountryPicker,
		UnAuthenticatedModels
	},
	computed: {
		...mapGetters('user', [
			'getUserData',
			'getProfilePicture',
			'isAuthenticated'
		]),
		...mapGetters('siteData', ['getSelectedCountry', 'getCountriesWithShipping'])
	},
	mounted () {
		this.profilePic = this.getUserData.image_url
	},
	methods: {
		logOut () {
			this.$emit('logOutUser')
		},
		toggleDropDown (dropDownId) {
			countrySelector.toggleDropDown(dropDownId)
			// this.$emit('toggleCountryDropDown', dropDownId);
		},
		userRoutes (to) {
			this.$router.push({
				name: to
			})
		}
	},
	watch: {
		getUserData () {
			this.profilePic = this.getUserData.image_url
		}
	}
}
</script>
